module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00060-fs8.bfb9ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00060-fs8.png
// module id = 213
// module chunks = 0